/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import Group from 'entities/Group';

import naturalSort from 'javascript-natural-sort';

class Groups extends Collection {
  initialize() {
    this.url = '/classes';
    this.model = Group;
  }

  comparator(a: Group, b: Group) {
    return naturalSort(a.getName().toLowerCase(), b.getName().toLowerCase());
  }

  static fetch() {
    return apiRequest('/classes', 'GET').then(response => Groups.fromJSON(response['classes']));
  }

  static fetchArchived() {
    return apiRequest('/classes/archived', 'GET').then(response => Groups.fromJSON(response['classes']));
  }

  static setGroupsAllowedToStartChat(groups: Object) {
    return apiRequest('/classes', 'PATCH', {
      classes: Object.keys(groups).map(groupId => {
        return {
          id: groupId,
          subscriber_initiated_chats: groups[groupId],
        };
      }),
    }).then(response => Groups.fromJSON(response['classes']));
  }

  static bulkUpdate(params) {
    return apiRequest('/classes', 'PATCH', {
      classes: params,
    }).then(response => Groups.fromJSON(response['classes']));
  }

  static linkUnassignedToPrimaryOrg() {
    return apiRequest('/classes/link_unassigned_to_primary_org', 'POST');
  }

  static find(teacherId) {
    return apiRequest('/classes/find', 'GET', {
      teacher_id: teacherId,
    }).then(response => Groups.fromJSON(response));
  }
}

export default Groups;



// WEBPACK FOOTER //
// ./src/collections/Groups.js